import React from 'react';
import { SmlsButton, SmlsModal } from '@smiles/smiles-ui-kit-react';
import { ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { TangModalHeader } from '../components/TangModalHeader';
import { LoginModal, useLoginModalFlow } from '../context/LoginModalFlowContext';
import { getLink } from '../../utils';
import { ImageModalWhiteCellphone } from '../assets/ImageModalWhiteCellphone';
import { trackLoginEvents } from '../utils/eventTracking';

export function PasswordBlockedModal() {
  const { t } = useTranslation('modais');
  
  const modalFlow = useLoginModalFlow();

  function toggleModal() {
    modalFlow.closeModal(LoginModal.PASSWORD_BLOCKED);
    trackLoginEvents.CreateNewPassword();
  }

  function handleResetPasswordRedirect () {
    window.location.href = getLink('recuperar/senha');
  }

  return (
    <SmlsModal
      type="right"
      isOpen={modalFlow.isModalOpen(LoginModal.PASSWORD_BLOCKED)}
      className="tang-modal"
      toggle={toggleModal}
      defaultHeader={false}
    >
      <TangModalHeader showCloseButton onClose={toggleModal} />
      <ModalBody data-testid="modal-body">
        <div className="modal-content">
          <div> 
            <div className="modal-icon">
              <ImageModalWhiteCellphone />
            </div>
            <p className="modal-title">{t('acesso_04.title')}</p>
            <p className="modal-subtitle">
              {t('acesso_04.text')}
            </p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className='one-button'>
        <SmlsButton className="button" text={t('acesso_04.button_primary')} onClick={handleResetPasswordRedirect} />
      </ModalFooter>
    </SmlsModal>
  );
}
